import template from './listActions.html';

export default function inListActions() {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            'buttons': '<',
            'entry': '<',
            'entity': '<',
            'onBtnClick': '&',
            'onEdit': '&',
            'onDelete': '&'
        },
        controller: ['$scope', function($scope) {

            $scope.actionClick = function(btnId) {
                var params = {
                    entity: $scope.entity,
                    entry: $scope.entry
                };
                $scope.onBtnClick({btnId: btnId, params: params});
            };

            $scope.edit = function() {
                $scope.onEdit({item: $scope.entry});
            };

            $scope.delete = function() {
                $scope.onDelete({item: $scope.entry});
            };
        }],
        link: function ($scope) {
            $scope.customTemplate = false;
            if (typeof $scope.buttons === 'string') {
                $scope.customTemplate = $scope.buttons;
                $scope.buttons = null;
            }
        },
        templateUrl: template
    };
}

inListActions.$inject = [];



// WEBPACK FOOTER //
// ./app/components/common/crud/list/listActions.js